export type WellKnownSpecifications =
  | 'cupSizes'
  | 'recipes'
  | 'aromatics'
  | 'intensity'
  | 'bitterness'
  | 'acidity'
  | 'roastLevel'
  | 'body'
  | 'decaf'
  | 'collection'
  | 'weight'
  | 'ingredients';

// Without a well defined key/code or value (ECAPI data incomplete) - Feature specifications do not have
// the needed data quality to use in Filters or Sorts
export type FeatureSpecification = {
  title: string;
  order: number;
  description?: string;
  measure?: number;
  unitOfMeasure?: string;
  value?: string | number;
  icon?: string;
};

export type PropertySpecification = {
  title: string;
  value: string | number | boolean;
  measure?: number;
  unitOfMeasure?: string;
  icon?: string;
};

export type Specification = FeatureSpecification | PropertySpecification;

export type Specifications = Record<
  WellKnownSpecifications | string,
  Specification | Specification[]
>;

export function getKnownProductSpecificationByKey<TSpec = Specification>(
  specifications: Specifications,
  key: WellKnownSpecifications
): TSpec {
  return specifications[key] as TSpec;
}
